import React from 'react';
import { Cpu, Users, Compass, Shield } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const iconMap = {
  strategy: Compass,
  governance: Shield,
  technologyData: Cpu,
  peopleChange: Users,
};

const WhatWeMeasure = () => {
  const { t } = useLanguage();

  // 4 dimensions matching the assessment categories - People & Change first
  const dimensions = [
    { id: 'peopleChange', icon: 'peopleChange', titleKey: 'peopleChange', descKey: 'peopleChangeDesc' },
    { id: 'governance', icon: 'governance', titleKey: 'governance', descKey: 'governanceDesc' },
    { id: 'strategy', icon: 'strategy', titleKey: 'strategy', descKey: 'strategyDesc' },
    { id: 'technologyData', icon: 'technologyData', titleKey: 'technologyData', descKey: 'technologyDataDesc' },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('whatWeMeasure')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('fourDimensions')}
          </p>
        </div>

        {/* Dimensions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {dimensions.map((dimension) => {
            const IconComponent = iconMap[dimension.icon];
            return (
              <div
                key={dimension.id}
                className="group bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-xl hover:border-blue-200 transition-all duration-300"
              >
                <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-blue-500 transition-colors duration-300">
                  <IconComponent className="h-7 w-7 text-blue-500 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {t(dimension.titleKey)}
                </h3>
                <p className="text-gray-600">
                  {t(dimension.descKey)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeMeasure;
